/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type PdpRespSidebarBlurbs_localDeliveryOptions = {| |};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSidebarBlurbs_localDeliveryOptions",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedBlurbShipping_localDeliveryOptions",
      "args": null
    }
  ],
  "type": "ShipmentQuoteConnection"
};

module.exports = fragment;
